// ============================================================================
// Print Ratio Types - SINGLE SOURCE OF TRUTH
// ============================================================================
// To add a new ratio:
// 1. Add entry to PRINT_RATIO_CONFIGS below
// 2. That's it! Everything else derives from this config.
// ============================================================================

export interface PrintRatioConfig {
  width: number;
  height: number;
  label: string;
}

export const PRINT_RATIO_CONFIGS = {
  '2:3': { width: 2000, height: 3000, label: '2:3 (Portrait)' },
  '4:5': { width: 2000, height: 2500, label: '4:5 (Instagram)' },
  '3:4': { width: 2100, height: 2800, label: '3:4 (Standard)' },
  'ISO': { width: 2100, height: 2970, label: 'ISO (A-Series)' },
  '5x7': { width: 1500, height: 2100, label: '5x7 (Frame)' },
  '11x14': { width: 2200, height: 2800, label: '11x14 (Frame)' },
} as const satisfies Record<string, PrintRatioConfig>;

export type PrintRatio = keyof typeof PRINT_RATIO_CONFIGS;
export const PRINT_RATIOS = Object.keys(PRINT_RATIO_CONFIGS) as PrintRatio[];
export const PRINT_RATIO_COUNT = PRINT_RATIOS.length;
